import { QueryString } from '@/types/common';

export const getUrlParams = (url?: string) => {
  const queryString: QueryString = {};

  (url || window.location.href).replace(/([^?&=]+)=([^&=]*)/gi, (rs, $1, $2) => {
    queryString[$1] = decodeURIComponent($2 as string);
    return rs;
  });
  return queryString;
};
